
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, CircularProgress, FormControl, InputLabel, Select, MenuItem, TextField, Paper } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';

import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { ObtenerTipoDependencia } from '../../connections/catalogos/TipoDependenciaConnection';
import { ActualizarDependencia, AgregarDependencia, Dependencias } from '../../connections/catalogos/DependenciaConnection';

import { TipoDependenciaProps } from '../../interfaces/catalogos/TipoDependenciaInterface';
import { DependenciaProps } from '../../interfaces/catalogos/DependenciaInterface';

export const DependenciaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [idDependencia, setIdDependencia] = useState( 0 );
    const [Dependencia, setDependencia] = useState<DependenciaProps[]>( [] );

    const [tipoDependencia, setTipoDependencia] = useState( 0 );
    const [tipoDependenciaArray, setTipoDependenciaArray] = useState<TipoDependenciaProps[]>( [] );

    const [descripcion, setDescripcion] = useState( '' );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const [filtroDependencia, setFiltroDependencia] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( Dependencia, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fd = filtroDependencia.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroDependencia === '' || ( item.tipoDependencia?.descripcion?.toLowerCase().includes( fd ) ?? false ) )
        );
    });

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const Dependenciaselected = Dependencia.find((elem) => elem.idDependencia === id);

        if (Dependenciaselected) {

            await ActualizarDependencia({ ...Dependenciaselected, activo: checked }).then(resp => {

                if (resp.idDependencia) {

                    var newArray = Dependencia.map((elem) => {

                        if (elem.idDependencia === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setDependencia(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));
                }

            });
        }

    }

    const handleGuardar = async () => {

        if (idDependencia !== 0) {

            const DependenciaSelected = Dependencia.find((elem) => elem.idDependencia === idDependencia);

            if ( DependenciaSelected ) {

                setLoading( true );

                await ActualizarDependencia({ ...DependenciaSelected, descripcion, idTipoDependencia: tipoDependencia, }).then(resp => {

                    if ( resp.idDependencia ) {

                        setTimeout(() => {

                            var newArray = Dependencia.map((elem) => {

                                if (elem.idDependencia === idDependencia) {
                                    elem.descripcion = descripcion;
                                    elem.idTipoDependencia = tipoDependencia;
                                    elem.tipoDependencia = resp.tipoDependencia
                                }

                                return elem;
                            });

                            setDependencia(newArray);
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const DependenciaAdd: DependenciaProps = {
                idDependencia: 0,
                descripcion,
                idTipoDependencia: tipoDependencia,
                activo: true,
            };

            setLoading( true );

            await AgregarDependencia(DependenciaAdd).then(resp => {

                if (resp.idDependencia) {

                    setTimeout(() => {

                        setDependencia([...Dependencia, resp]);
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó la dependencia correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setDependencia( [] );

            await Dependencias().then(resp => {

                setTimeout(() => {

                    setDependencia(resp);
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function obtener() {

            setTipoDependenciaArray( [] );

            await ObtenerTipoDependencia().then(resp => {

                setTimeout(() => {

                    setTipoDependenciaArray(resp);

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Dependencias' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdDependencia( 0 );
                            setTipoDependencia( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>

                    <SearchTextField
                        value={ filtroDependencia }
                        label='Buscar por dependencia'
                        onChange={ ( value ) => {
                            setFiltroDependencia( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '45%', }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%' }}> Tipo Dependencia </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    :
                                    dataFiltrada
                            )
                                .map(({ idDependencia, descripcion, activo, idTipoDependencia, tipoDependencia,  }) => (

                                    <TableRow key={ idDependencia } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            {idDependencia}
                                        </TableCell>

                                        <TableCell>
                                            {descripcion}
                                        </TableCell>

                                        <TableCell>
                                            {tipoDependencia?.descripcion}
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked(e.target.checked, idDependencia) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdDependencia( idDependencia );
                                                    setTipoDependencia( idTipoDependencia ? idTipoDependencia : 0 );
                                                    setDescripcion( descripcion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {dataFiltrada.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <FormControl fullWidth>
                                <InputLabel>Tipo Dependencia</InputLabel>

                                <Select
                                    label='Tipo Dependencia'
                                    value={ tipoDependencia }
                                    onChange={ (e) => setTipoDependencia( parseInt(e.target.value.toString() ?? '0') ) }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoDependenciaArray.map((elem) => (
                                            <MenuItem key={ elem.idTipoDependencia } value={ elem.idTipoDependencia }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={ 'Descripción' }
                                variant='outlined'
                                multiline
                                rows={ 4 }
                                fullWidth
                                value={ descripcion }
                                onChange={ (e) => setDescripcion(e.target.value) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); }}> Cancelar </Button>
                    <Button loading={ loading } disabled={ tipoDependencia === 0 } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}

